/**
 * Drill entity (database table) → the route that opens one of its records.
 *
 * Single source of truth. This map used to be copy-pasted into DrilldownGrid
 * and RecordListWidget, which is how a wrong entry survived in one of them
 * after the other was looked at. Any widget that turns a drill row into a link
 * imports from here.
 *
 * A builder receives the id the row is LINKED by — the row's own `id` unless
 * the drill spec named a `link_column` (see recordLinkId below) — and the full
 * row, for the rare destination that needs more than one field.
 *
 * `hazards` is the entry that needs care. A HIRA hazard is a line inside a risk
 * assessment and has no page of its own, so it opens its parent HIRA. Sending
 * it to `/hazards/<id>` looks right and is not: /hazards/* is a LEGACY ALIAS
 * for the INCIDENT screens (pages/HazardDetail.js defaults to
 * entity='incident'), so that click fetched GET /api/incidents/<hazard id> and
 * failed with "Failed to load incident details". Two unrelated record families
 * share the word "hazard"; only the incident one owns the /hazards route.
 */
export const ENTITY_ROUTES = {
  incidents: (id) => `/incidents/${id}`,
  hazards: (riskAssessmentId) => `/hira/${riskAssessmentId}`,
  observations: (id) => `/observations/${id}`,
  capas: (id) => `/capa/${id}`,
  audit_records: (id) => `/audits/detail/${id}`,
  risk_assessments: (id) => `/hira/${id}`,
};

/** The route builder for a drilldown response, or undefined if none is known. */
export function routeBuilderFor(data) {
  return ENTITY_ROUTES[data?.entity];
}

/**
 * The id a row should be opened by. The server names a `link_column` only
 * where it differs from the row's own id. Returns null when that field is
 * empty — the caller must then leave the row inert rather than navigate
 * somewhere that cannot load.
 */
export function recordLinkId(data, row) {
  if (!row) return null;
  return row[data?.link_column || 'id'] || null;
}
